import visitsApi from '@/api/visits';

const state = {
    isLoading: false,
    validationErrors: null,
    isSubmitting: false,
    visits:null
}

export const mutationTypes = {
    countVisitsStart: '[account] Make payment start',
    countVisitsSuccess: '[account] Make payment success',
    countVisitsFailure: '[account] Make payment failure',
}

export const visitsActionTypes = {
    countVisits: '[visits] Count visits',
}

const mutations = {
    [mutationTypes.countVisitsStart](state) {
        state.isLoading = true
        state.listVisitor = null
    },
    [mutationTypes.countVisitsSuccess](state, payload) {
        state.isLoading = false
        state.visits = payload
        state.validationErrors = null
    },
    [mutationTypes.countVisitsFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

}

const actions = {
    [visitsActionTypes.countVisits](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.countVisitsStart)
            visitsApi
                .countVisits(data)
                .then(response => {
                    context.commit(mutationTypes.countVisitsSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.countVisitsFailure,response)
                })
        })
    },
}

export default {
    state,
    actions,
    mutations
}